import styled from 'styled-components';

export const Container = styled.div`
  width: 50px;
  float: left;
  transition: all 0.5s ease;
  height: 50px;
  margin: 0;

  @media (max-width: 1024px) {
    margin: 0;
    width: 100%;
  }
`;

export const Control = styled.div`
  width: 50px;
  height: 50px;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 290px;
  margin-left: -258px;
  margin-top: -30px;
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: 2000;
  align-items: flex-start;
  justify-content: flex-start;
  background: ${({ theme }) =>
    `linear-gradient(0deg, #f0f 0%, #f0f 100%)`};
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  padding: 14px 15px;
  border-radius: 10px;
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};


  img {
    float: left;
    max-width: 100%;
    max-height: 100px;
    height: auto;
    border-radius: 0.6rem;
    margin-bottom: 1rem;
  }
  span {
    background: ${({ theme }) => theme.colors.TEXT1};
  }

  small {
    background: ${({ theme }) => theme.colors.TEXT1};
  }

  div {
    width: 100%;
    display: flex;
    flex-direction: row;
    float: left;
    margin: 1rem 0 0 0;
  }

  
  button {
    float: left;
    width: 100%;
    margin-bottom: 5px;
    padding: 1rem 0.5rem;
    border-radius: 0.4rem;
    transition: all 0.5s ease;

    &:hover {
      background: #222;
    }

    span {
      font-size: 0.8rem;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.TEXT1};
    }
  }

  .collapse-delete {
    background: #ff4545;
    margin-right: 0.5rem;
  }
  .collapse-edit {
    background: #01cfff;
  }

  @media (max-width: 1024px) {
    align-items: flex-start;
  }

  p {
    font-size: 12px;
    float: left;
    margin: 10px 0 0;

    strong {
      font-size: 10px;
      background: #333;
      color: ${({ theme }) => theme.colors.TEXT1};
      padding: 4px;
      float: left;
    }
  }
`;
